'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, n) {
    return r in e ? Object.defineProperty(e, r, {
        value: n,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = n, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var n = null != arguments[r] ? arguments[r] : {}, t = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(n).filter(function(e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), t.forEach(function(r) {
            _define_property(e, r, n[r]);
        });
    }
    return e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var n, t, o = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(t = 0; t < s.length; t++)n = s[t], !(r.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
    return o;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var n, t, o = {}, s = Object.keys(e);
    for(t = 0; t < s.length; t++)n = s[t], r.indexOf(n) >= 0 || (o[n] = e[n]);
    return o;
}
const Spinner = renderWithRef('Spinner', null, (t, i)=>{
    useDeprecatedProps('Spinner', t, [
        {
            propName: 'size',
            deprecatedValues: {
                mini: 'Use size="standard" instead',
                tiny: 'Use size="standard" instead'
            }
        }
    ]), useComponentStylesLoaded('Spinner', SWAN_STYLE_KEY_MAP.spinner);
    let { size: p = 'standard', accessibleText: c, layout: l = 'vertical', showText: d = false, overlay: u = false } = t, f = _object_without_properties(t, [
        "size",
        "accessibleText",
        "layout",
        "showText",
        "overlay"
    ]), m = new Set([]);
    return m.add('swan-spinner'), 'standard' !== p && m.add(`swan-spinner-${p}`), 'horizontal' === l && m.add("swan-spinner-horizontal"), d && m.add("swan-spinner-show-text"), u && m.add("swan-spinner-overlay"), jsxs(RenderComp, {
        root: "span",
        forwardedRef: i,
        classNames: m,
        props: _object_spread({}, f),
        children: [
            jsx("span", {
                className: "swan-spinner-animation",
                children: jsx("span", {
                    className: "swan-spinner-animation-inner"
                })
            }),
            jsx("span", {
                className: "swan-spinner-text",
                children: c
            })
        ]
    });
});

export { Spinner };
